import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { FormButton, Button } from '@components';
import type { IForgotPasswordScreenStore } from '../ForgotPasswordScreen';

interface ISubmitButtonProps {
  store: IForgotPasswordScreenStore;
}

export const SubmitButton = observer<ISubmitButtonProps>(
  ({ store }) => {
    const { t } = useTranslation();

    const submitButtonText = store.isSent
      ? t('forgotPassword.sentItAgain')
      : t('forgotPassword.reset');

    if (store.isActiveCountdown) {
      return (
        <Button disabled>
          {t('forgotPassword.sendAgainIn', {
            seconds: store.countdownTimeLeftInSeconds,
          })}
        </Button>
      );
    }

    return <FormButton>{submitButtonText}</FormButton>;
  },
);
